<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Edit Unit</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="4">
            <base-input label="Unit Full Name"
                        name="longName"
                        type="textarea"
                        placeholder="Cup"
                        rules="required"
                        v-model="model.longName">
            </base-input>
          </b-col>
          <b-col md="4">
            <base-input label="Unit Abbreviation"
                        name="name"
                        type="textarea"
                        placeholder="C (optional"
                        v-model="model.name">
            </base-input>
          </b-col>
          <b-col md="4">
            <base-input label="Unit Plural Name"
                        name="pluralName"
                        type="textarea"
                        placeholder="Cups"
                        rules="required"
                        v-model="model.pluralName">
            </base-input>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Show When Zero?
            </label><br />
            <base-switch label="Show When Zero?"
                    name="showWhenZero"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.showWhenZero">
            </base-switch>
          </b-col>
        </div>
        <base-button type="primary" native-type="submit">Save Unit</base-button>
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import DropzoneFileUpload from '../../components/Inputs/DropzoneFileUpload.vue';
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import Instructions from '../Components/Instructions.vue';
  import { authHeader } from '../../_helpers';
  import axios from 'axios'

  const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/units/`,
    withCredentials: false,
    headers: authHeader()
  })

  export default {
    name: "EditUnit",
    components: {
        HtmlEditor,
        DropzoneFileUpload,
        [Select.name]: Select,
        [Option.name]: Option,
        Instructions
    },
    data() {
      return {
        model: {
          id: '',
          name: '',
          longName: '',
          pluralName: '',
          showWhenZero: true,
          isActive: true,
          isDeleted: false
        }
      }
    },
    methods: {
      firstFormSubmit() {
        const { dispatch } = this.$store;
        this.model.name = (this.model.name=='') ? this.model.longName : this.model.name
        if (this.model.name) {
          try {
              dispatch("units/updateUnit", this.model)
                  .then(response => {
                  this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Unit Updated'});
                  this.$router.push({path: "/units"});
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: unit add", error);
          }
        }
      },
      getUnit(id) {
        return apiClient.get(`${id}`);
      }
    },
    computed: {
    },
    created() {
      this.model.id = this.$route.params.id;
      this.getUnit(this.model.id)
        .then(response => {
          this.model = response.data;
        })
        .catch(error => {
          console.log(error)
        });
    },
    mounted() {
      
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
